<template>
  <footer v-if="isAuthenticated">
    <nav class="smile-header-nav-mobile">

      <router-link :to="{ path: '/' }">
        <div class="smile-mobile-menu-image">
          <img src="@/assets/images/home.svg"
               alt="Αρχική Σελίδα"
               :class="{ 'smile-mobile-menu-image-selected': isExactActive('home') }">
        </div>
        <div class="smile-mobile-menu-text">
          Αρχική
        </div>
      </router-link>

      <router-link :to="{ path: '/loyalty-card' }">
        <div class="smile-mobile-menu-image">
          <img src="@/assets/images/credit-card.svg"
               alt="Smile κάρτα"
               :class="{ 'smile-mobile-menu-image-selected': isExactActive('loyalty-card') }">
        </div>
        <div class="smile-mobile-menu-text">
          Κάρτα
        </div>
      </router-link>

      <router-link :to="{ path: '/invoices' }" :class="exactActiveClass('invoices')">
        <div class="smile-mobile-menu-image">
          <img src="@/assets/images/istoriko.svg"
               :class="{ 'smile-mobile-menu-image-selected': isExactActive('invoices') }"
               alt="Ιστορικό Αγορών">
        </div>
        <div class="smile-mobile-menu-text">
          Ιστορικό
        </div>
      </router-link>

      <router-link :to="{ path: '/points' }" :class="exactActiveClass('points')">
        <div class="smile-mobile-menu-image">
          <img src="@/assets/images/simeia.svg"
               alt="Τα Σημεία Μας"
               :class="{ 'smile-mobile-menu-image-selected': isExactActive('points') }">
        </div>
        <div class="smile-mobile-menu-text">
          Σημεία
        </div>
      </router-link>

      <router-link :to="{ path: '/account' }" :class="exactActiveClass('account')">
        <div class="smile-mobile-menu-image">
          <img src="@/assets/images/profile.svg"
               alt="Το Προφίλ Μου"
               :class="{ 'smile-mobile-menu-image-selected': isExactActive('account') }">
        </div>
        <div class="smile-mobile-menu-text">
          Προφίλ
        </div>
      </router-link>

    </nav>
  </footer>
</template>
<script>

export default {
  name: 'AppFooter',
  props: {
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      exactActiveClass: (linkPathName = '') => {
        if (this.$route.meta.linkPath === linkPathName) {
          return 'router-link-exact-active';
        }

        return '';
      },
      isExactActive: (linkPathName = '') => {
        if (this.$route.meta.linkPath === linkPathName) {
          return true;
        }

        return false;
      },
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue